module.exports = __webpack_public_path__ + "static/media/security.f483e75c.png";